var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},_vm._l((_vm.list),function(item){return _c('CategoryItem',{key:item.id,attrs:{"item":item,"locale":_vm.locale},on:{"delCategory":_vm.delCateogry}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }